import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { PatientStrengthAndCautionOptionsResponse } from "@/core/types";

import { getStrengthCautionOptions } from "../queryFunctions/getStrengthCautionOptions";
import { memberCarePlanKeys } from "../keyFactory";

type UseStrengthCautionOptionsProps<TData = PatientStrengthAndCautionOptionsResponse> = {
  patientId: string;
  select?: (data: PatientStrengthAndCautionOptionsResponse) => TData;
};

type StrengthCautionOptionsQueryOptions = UseQueryOptions<
  PatientStrengthAndCautionOptionsResponse,
  unknown,
  PatientStrengthAndCautionOptionsResponse,
  ReturnType<typeof memberCarePlanKeys.strengthCautionOptions>
>;

export function useStrengthCautionOptions<TData = PatientStrengthAndCautionOptionsResponse>({
  patientId,
  select,
}: UseStrengthCautionOptionsProps<TData>) {
  return useQuery({ ...optionFactory(patientId), select });
}

export function optionFactory(patientId: string) {
  return {
    queryFn: () => getStrengthCautionOptions(patientId),
    queryKey: memberCarePlanKeys.strengthCautionOptions(patientId),
  } satisfies StrengthCautionOptionsQueryOptions;
}
